export const namespace = 'trafficChannel';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
}

export const ActionType = {
  SET_TRAFFIC_CHANNELS: `${namespace}/SET_TRAFFIC_CHANNELS`,
}

export const setTrafficChannels = (trafficChannels = []) => ({
  type: ActionType.SET_TRAFFIC_CHANNELS,
  payload: {
    trafficChannels
  }
})
